import { config as gaConfig } from './ga'

const config = {
  ga: gaConfig,
}

export { config }
